import { OnChangeParams, TYPE } from 'baseui/select';
import React from 'react';
import FormControl from '../../../../../presentation/components/FormControl';
import Select from '../../../../../presentation/components/Select';
import BillingPeriodSet from '../../../../../entities/BillingPeriodSet';

interface BillingPeriodFormControlProperties {
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  billingPeriodSet: BillingPeriodSet;
}

const BillingPeriodStartFormControl: React.FC<BillingPeriodFormControlProperties> = ({
  selectedIndex,
  setSelectedIndex,
  billingPeriodSet
}) => {
  return (
    <FormControl
      label={
        <span className="visually-hidden" id="billing-period-start-label">
          Auswahl des Startdatums der Abrechnungsperiode
        </span>
      }
    >
      <Select
        clearable={false}
        closeOnSelect
        options={billingPeriodSet.getBillingPeriods().map((item, index) => {
          return {
            label: (
              <div data-gi={`${index}`}>
                {item.getStart().toLocaleDateString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                })}
              </div>
            ),
            id: index
          };
        })}
        value={[
          {
            label: billingPeriodSet.getBillingPeriodByIndex(selectedIndex),
            id: selectedIndex
          }
        ]}
        valueKey="id"
        onChange={(params: OnChangeParams) => setSelectedIndex(+params.option!.id!)}
        type={TYPE.select}
        additionalTestId="startDate"
        aria-labelledby="billing-period-start-label"
      />
    </FormControl>
  );
};

export default BillingPeriodStartFormControl;
